import { ContactService } from "@/services";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

import $enDigits from "@/mixins/enDigits";

export default {
  name: "mobile",
  components: { CountDown },
  mixins: [$enDigits],
  data() {
    return {
      mobileInput: "",
      mobileCode: "",
      isMobileHover: false,
      isMobileFocus: false,
      isCountDownFinish: false,
      isRequesting: false,
      ttl: ""
    };
  },
  computed: {
    ...mapGetters({
      isModalOpen: types.mobile.getters.IS_MODAL_OPEN,
      modalStep: types.mobile.getters.MODAL_STEP,
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),

    dialogHeight() {
      switch (this.modalStep) {
        case 1:
          return "height: 330px;";

        case 2:
          return "height: 420px;";
      }
    },

    mobileData() {
      return this.userInfo?.mobile;
    },

    isVerify() {
      return this.userVerifyInfo?.mobile_verification_status === "VERIFIED";
    },

    mobileModal: {
      get() {
        return this.isModalOpen;
      },
      set(val) {
        this.setModal(val);
      }
    },

    emailNameClass() {
      if (this.isMobileFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isMobileValid) {
          return "mobile_name_error";
        } else {
          if (this.mobileInput) {
            return "mobile_name_fill";
          } else {
            if (this.isMobileHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },

    isMobileValid() {
      if (this.mobileInput) {
        const mobileRegex = /^(09)\d{9}/;
        return mobileRegex.test(this.mobileInput);
      }
      return true;
    },

    isMobileCodeValid() {
      if (this.mobileCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.mobileCode);
      }
      return true;
    }
  },
  mounted() {
    if (this.mobileData) {
      this.mobileInput = this.mobileData;
    }
  },
  methods: {
    ...mapActions({
      setStep: types.mobile.actions.SET_STEP,
      setModal: types.mobile.actions.SET_MODAL,
      setMobile: types.userVerifyInfo.actions.SET_MOBILE_STATUS
    }),

    openModal() {
      this.setModal(true);
    },

    openModalStep1() {
      this.setStep(1);
      this.setModal(true);
    },

    closeMobileModal() {
      this.setModal(false);
    },

    // openModalStep2() {
    //   !this.isRequesting &&
    //     ContactService.activeMobile(this.mobileData)
    //       .then(() => {
    //         this.setStep(2);
    //         this.setModal(true);
    //       })
    //       .finally(() => this.finishRequest());
    //   this.startRequest();
    // },

    setMobileHover(bool) {
      this.isMobileHover = bool;
    },

    toggleMobileFocus() {
      this.isMobileFocus = !this.isMobileFocus;
    },

    handleFinishCountDown() {
      this.isCountDownFinish = true;
      this.ttl = "";
    },

    resetCounter() {
      this.isCountDownFinish = false;
    },

    activeMobile() {
      if (this.mobileInput && this.isMobileValid) {
        ContactService.activeMobile(this.mobileInput)
          .then(res => {
            this.ttl = res.data.data.ttl;
            this.resetCounter();
            this.setStep(2);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    reActiveMobile() {
      ContactService.activeMobile(this.mobileInput)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetCounter();
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },

    verifyMobile() {
      if (this.isMobileCodeValid) {
        ContactService.verifyMobile(this.mobileCode)
          .then(res => {
            this.setMobile("VERIFIED");
            this.closeMobileModal();
            this.$toast.success(res.data.message);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    }
  },

  watch: {
    mobileInput(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      const digitReg = /^\d+$/;
      const isDigit = digitReg.test(value);
      if (newValue) {
        if (!isDigit) {
          this.mobileInput = oldValue;
        }
      }
    },

    mobileCode(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.mobileCode = value;
      const regex = /^\d+$/;
      const isCodeValid = regex.test(value);
      if (newValue) {
        if (!isCodeValid) {
          this.mobileCode = oldValue;
        }
      }
    }
  }
};
